import React from "react";

export default function ProjectDetails() {
  return (
    <>
      <section className="project-details-section fix section-padding">
        <div className="container">
          <div className="project-details-wrapper">
            <div className="row g-4">
              <div className="col-lg-12">
                <div className="project-details-items">
                  <div className="details-image">
                    <img src="assets/img/project/Sus_6.gif" alt="Eco-friendly products in real spaces" width="1290" height="613" />
                  </div>
                  <div className="project-details-content">
                    {/* <p className="mb-2">Construction, Architecture</p> */}
                    <h2>♻️ Sustainability at V-Make
                    </h2>
                    <p className="mb-3 mt-3">
                      At V-Make, sustainability isn't just a buzzword—it's the foundation of everything we create. Our WPC doors and frames are manufactured using eco-conscious processes and recyclable materials, reducing the need for deforestation and minimizing environmental impact.
                    </p>
                    <p className="mb-3">
                      By choosing WPC over traditional wood, we’re actively helping to conserve forests, reduce plastic waste, and create durable products that last longer and require zero maintenance—making them a better choice for the planet and future generations.


                    </p>
                    <div className="project-infor-wrapper">
                      <div className="row g-4">
                        <div className="col-xl-7">
                          <h3>🔄 Going Beyond The Usual</h3>
                          <p className="mt-3 mb-3">
                            At V-Make, we go beyond just creating doors and frames—we build a future of sustainability and innovation. Our commitment is not only to deliver durable WPC solutions but to also reduce environmental impact through eco-conscious materials, energy-efficient manufacturing, and long-term recyclable products. We believe innovation must serve both people and the planet.
                          </p>
                          <h3>🎯 Project Goal</h3>
                          <p className="mt-3">
                            Our sustainability project aims to reshape how building materials contribute to the environment and community. Here’s what drives us forward :
                          </p>
                          <ul className="details-list">
                            <li>
                              <i className="fa-solid fa-circle-check" />
                              Promote sustainable architecture through WPC technology
                            </li>
                            <li>
                              <i className="fa-solid fa-circle-check" />
                              Reduce deforestation by offering wood-alternative materials
                            </li>
                            <li>
                              <i className="fa-solid fa-circle-check" />
                              Empower architects and dealers with eco-friendly, low-maintenance products
                            </li>
                            <li>
                              <i className="fa-solid fa-circle-check" />
                              Encourage green construction practices with lead-free, recyclable solutions
                            </li>
                          </ul>
                          <p>
                            V-Make follows global sustainability standards to meet current needs while protecting future resources. We're committed to creating a greener tomorrow.
                          </p>
                        </div>
                        <div className="col-xl-5">
                          <div className="details-image">
                            <img
                              src="assets/img/project/Sus_3.png" width="527" height="497"
                              alt="Stacked beige WPC foam boards placed on soil with green leaves in the background, showcasing eco-friendly and sustainable material."
                              className="img-fluid"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <h3 className="mt-3 mb-3">Project Summery</h3>
                    <div className="row g-4">
                      <div className="col-md-6">
                        <p className="mb-4">
                          At V-Make, sustainability is more than a goal—it’s embedded in our process. This project showcases our commitment to using eco-friendly materials like WPC foam boards and doors that reduce reliance on traditional wood. These products are not only 100% recyclable but also built for long-term durability.
                        </p>
                        <div className="details-image">
                          <img
                            src="assets/img/project/Sus_4.png"
                            alt="High-quality WPC boards stacked in a warehouse, representing sustainable product inventory."
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <p className="mb-4">
                          By integrating modern manufacturing practices, we've achieved lower emissions, reduced waste, and optimized energy use throughout production. This project is a step forward in creating sustainable infrastructure that supports both architectural excellence and responsible environmental stewardship.
                        </p>
                        <div className="details-image">
                          <img
                            src="assets/img/project/Sus_5.png"
                            alt="Close-up view of WPC foam boards symbolizing eco-friendly construction materials."
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
